import { useState, useEffect } from 'react';
import { Modal, Form, Button, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * Notes captured when an alert is actioned. Completion clears the alert for
 * every staff member, so these notes are how everyone else finds out what was
 * done - hence the prompt rather than a silent tick.
 */
const CompleteAlertModal = ({ show, alert, onHide, onConfirm, isCompleting }) => {
  const [notes, setNotes] = useState('');

  useEffect(() => {
    if (show) setNotes('');
  }, [show, alert?.id]);

  const handleSubmit = e => {
    e.preventDefault();
    onConfirm(notes.trim());
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-0">Complete alert</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {alert && (
            <div className="bg-light rounded p-3 mb-3">
              <div className="fw-semi-bold text-800">{alert.title}</div>
              {alert.body && (
                <p className="mb-0 text-600 fs--1 mt-1">{alert.body}</p>
              )}
            </div>
          )}
          <Form.Group>
            <Form.Label className="fs-0 fw-medium">
              What was done? (optional)
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={notes}
              onChange={e => setNotes(e.target.value)}
              placeholder="e.g. Called the donor, new card added and payment retried"
              autoFocus
            />
            <Form.Text className="text-muted">
              This alert will be cleared for all staff. Your name, the time, and
              these notes are recorded against it.
            </Form.Text>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={isCompleting}>
            Cancel
          </Button>
          <Button type="submit" variant="success" disabled={isCompleting}>
            {isCompleting ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Completing...
              </>
            ) : (
              'Mark as completed'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

CompleteAlertModal.propTypes = {
  show: PropTypes.bool.isRequired,
  alert: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    body: PropTypes.string
  }),
  onHide: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isCompleting: PropTypes.bool
};

export default CompleteAlertModal;
